import styled from 'styled-components';
import { ITextFieldProps, TextField } from './TextField';
import { MATERIAL_ICONS_TYPES, MATERIAL_ICONS } from '../Icon/icons';

export interface IEmailInputProps
  extends Omit<
    ITextFieldProps,
    'type' | 'startIcon' | 'startIconType' | 'startText' | 'endIcon' | 'endIconType' | 'endText' | 'onStartIconClick' | 'onEndIconClick'
  > {}

export const EmailInput = styled(TextField).attrs<IEmailInputProps>((args) => ({
  ...args,
  startIcon: MATERIAL_ICONS.Email,
  startIconType: MATERIAL_ICONS_TYPES.OUTLINE,
  type: 'email'
}))``;
